
const WeakSet = require('core-js/fn/weak-set');

const _ = require('lodash');
const ko = require('knockout');

const $ = require('rgs-jquery');
require('rgs-datatable');


function koDataTableCreatedCell (columnDefinition, columnTemplates, parentBindingContext) {
	return function koDataTableCreatedCell (td, cellData, rowData, rowIndex, cellIndex) {
		const template = columnTemplates[cellIndex];
		const cellViewModel = columnDefinition.ko.data === true
				? rowData
				: _.get(rowData, columnDefinition.ko.data);
		const childBindingContext = parentBindingContext.createChildContext(
			cellViewModel,
			null,
			function (context) {
				_.extend(context, {
					'$dataTable': {
						'row': rowData,
					},
				});
			}
		);
		ko.applyBindingsToNode(td, {
			template: {
				nodes: template.nodes,
				data: cellViewModel,
			},
		}, childBindingContext);
	};
}

const boundHeaderElements = new WeakSet();
function koDataTableHeaderCallback (koHeaderOptions, parentBindingContext) {
	return function koDataTableHeaderCallback (thead, data) {
		if (boundHeaderElements.has(thead)) {
			return;
		}
		boundHeaderElements.add(thead);
		const headerViewModel = koHeaderOptions.data;
		if (koHeaderOptions.rowsCount) {
			_.extend(headerViewModel, { 'rowsCount': data.length });
		}
		const childBindingContext = parentBindingContext.createChildContext(
			headerViewModel,
			null,
			_.noop
		);
		ko.applyBindings(childBindingContext, thead);
	};
}

function koDataTableEventProxy (handler, api, contextElement) {
	return function koDataTableEventProxy (...args) {
		if (args.length === 1 && args[0] instanceof $.Event) {
			// default native & jquery event handler arguments for events like `click`
			// are not very useful, we call such handlers with the data arguments
			// just like ko does
			const [ e, ...rest ] = args;
			const $tr = $(e.target).closest('tr', contextElement);
			const data = api.row($tr).data();
			return handler(data, e, ...rest);
		}
		return handler(...args);
	};
}

ko.bindingHandlers.dataTable = {
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		const $element = $(element);

		const templates = (function () {
			const tbodyTds = $element
				.children('tbody').first()
				.children('tr').first()
				.children('td')
				.detach();

			return {
				columns: _.map(tbodyTds, td => {
					return {
						nodes: $(td).children().clone().toArray(),
					};
				}),
			};
		}());

		let api = null;

		function reinit () {
			const unwrappedValue = ko.unwrap(valueAccessor());

			let [ options, apiCallback ] = (() => {
				if (_.isArray(unwrappedValue)) {
					return unwrappedValue;
				}
				return [ unwrappedValue, _.noop ];
			})();

			options = _.mapValues(ko.unwrap(options), ko.unwrap);

			ko.ignoreDependencies(() => {
				if (api) {
					api.destroy();
				}

				if (_.get(options, 'ko.cells')) {
					_.each(options.columns, column => {
						if (!column.ko) {
							return;
						}

						const createdCell = koDataTableCreatedCell(
							column, templates.columns, bindingContext
						);

						column.createdCell = createdCell;
					});
				}

				if (_.get(options, 'ko.header.data')) {
					const headerCallback = koDataTableHeaderCallback(
						options.ko.header, bindingContext
					);
					options.headerCallback = headerCallback;
				}

				api = $element.DataTable(options);

				_.each(options.event, (handler, eventName) => {
					const proxiedHandler = koDataTableEventProxy(handler, api, element);
					api.off(eventName).on(eventName, proxiedHandler);
				});

				apiCallback(api);
			});
		}

		ko.computed(() => {
			reinit();
		}, null, {
			disposeWhenNodeIsRemoved: element,
		}).extend({
			rateLimit: {
				timeout: 300,
				method: 'notifyWhenChangesStop',
			},
		});

		return { controlsDescendantBindings: true };
	},
};

